import { Component } from 'react';
import moment from 'moment';
import classNames from 'classnames/bind';
import autoBind from 'react-autobind';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown';

import withComponentName from '../../../../../decorators/withComponentName';

import FiltersMobileModal from '../FiltersMobileModal';
import FilterInner from './FilterInner';

import Styles from '../styles.module.scss';

const cx = classNames.bind(Styles);

class YearsFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openFilterModal: false,
      dropdown: {
        open: false,
        isSelectAll: true,
        showUndated: true,
        fromYear: '',
        toYear: '',
        options: [],
      },
    };
    autoBind(this);
  }

  componentDidMount() {
    this.generateData();
  }

  componentDidUpdate(prevProps) {
    const { isReset } = this.props;
    if (isReset && isReset !== prevProps.isReset) {
      const { dropdown } = this.state;
      this.setState({
        dropdown: {
          ...dropdown,
          isSelectAll: true,
          showUndated: true,
        },
      });
    }
  }

  generateData() {
    const {
      isAllYearsSelected, fromYear, toYear, showUndated, isEsg,
    } = this.props;
    const minYear = 2000;
    const currentYear = moment().year() + (isEsg ? 0 : 1);
    const totalGap = currentYear - minYear;
    const options = [];
    for (let i = 0; i <= totalGap; i += 1) {
      options.push({
        id: i + 1,
        title: minYear + i,
        value: minYear + i,
      });
    }
    const { dropdown } = this.state;
    this.setState({
      dropdown: {
        ...dropdown,
        options,
        isSelectAll: isAllYearsSelected,
        showUndated,
        fromYear: fromYear || options[0].value,
        toYear: toYear || options[options.length - 1].value,
      },
    });
  }

  toggleDropdown(status, event, source) {
    const { width } = this.props;
    const { dropdown } = this.state;

    // workaround for IE11 to prevent double toggle when user clicks on
    // dropdown button to close dropdown
    if (
      status === false
      && source.source === 'select'
    ) {
      return;
    }

    if (width <= 1024) return this.openFilterModal();

    this.setState({
      dropdown: {
        ...dropdown,
        open: status,
      },
    });
  }

  openFilterModal() {
    const { openFilterModal } = this.state;

    this.setState({ openFilterModal: !openFilterModal });
  }

  handleCloseModal() {
    this.setState({ openFilterModal: false });
  }

  handleSelectAll() {
    const { dropdown } = this.state;
    const newOptions = dropdown.options.map((obj) => ({
      ...obj, select: !dropdown.isSelectAll,
    }));
    this.setState({
      dropdown: {
        ...dropdown,
        isSelectAll: !dropdown.isSelectAll,
        options: newOptions,
      },
    }, () => {
      this.saveDataIntoProps();
    });
  }

  handleOptionSelect(value, type) {
    const { dropdown } = this.state;
    const { piwikEnabled } = this.props;

    if (type === 'from') {
      this.setState({
        dropdown: {
          ...dropdown,
          fromYear: value,
        },
      }, () => {
        this.saveDataIntoProps();
      });
    } else {
      this.setState({
        dropdown: {
          ...dropdown,
          toYear: value,
        },
      }, () => {
        this.saveDataIntoProps();
      });
    }
    if (piwikEnabled) {
      _paq.push(['trackEvent', 'ESG, IR filters', `year ${value}`]);
    }
  }

  handleShowUndatedSelect() {
    this.setState(({ dropdown }) => ({
      dropdown: {
        ...dropdown,
        showUndated: !dropdown.showUndated,
      },
    }), () => {
      this.saveDataIntoProps();
    });
  }

  saveDataIntoProps() {
    const { savePropsData } = this.props;
    const { dropdown } = this.state;
    const {
      isSelectAll, fromYear, toYear, showUndated,
    } = dropdown;

    savePropsData({
      isAllYearsSelected: isSelectAll,
      fromYear,
      toYear,
      showUndated,
    });
  }

  render() {
    const { width, isEsg, isIR } = this.props;
    const { dropdown, openFilterModal } = this.state;

    return (
      <Dropdown
        id={cx('investor-years-filter-dropdown')}
        className={cx('common-seo-filters_btn', { esg: isEsg, ir: isIR })}
        show={dropdown.open}
        onToggle={this.toggleDropdown}
      >
        <Dropdown.Toggle>
          <div className={Styles.header_btn}>
            <div className={Styles.header_holder}>
              <div className={Styles.main_header}>
                {
                  dropdown.isSelectAll ? 'All Years' : `${dropdown.fromYear} - ${dropdown.toYear}`
                }
              </div>
              <div className={Styles.sub_header}>Year</div>
            </div>
            <div className={Styles.header_icon}>
              <FontAwesomeIcon icon={dropdown.open ? faChevronUp : faChevronDown} />
            </div>
          </div>
        </Dropdown.Toggle>
        {width >= 1025 ? (
          <Dropdown.Menu flip={false}>
            <FilterInner
              isEsg={isEsg}
              isIR={isIR}
              options={dropdown.options}
              fromYear={dropdown.fromYear}
              toYear={dropdown.toYear}
              isSelectAll={dropdown.isSelectAll}
              showUndated={dropdown.showUndated}
              handleSelectAll={this.handleSelectAll}
              handleOptionSelect={this.handleOptionSelect}
              handleShowUndatedSelect={this.handleShowUndatedSelect}
            />
          </Dropdown.Menu>
        ) : (
          <FiltersMobileModal
            openFilter={openFilterModal}
            handleCloseModal={this.handleCloseModal}
            width={width}
            showCloseIcon
          >
            <FilterInner
              isEsg={isEsg}
              isIR={isIR}
              options={dropdown.options}
              fromYear={dropdown.fromYear}
              toYear={dropdown.toYear}
              isSelectAll={dropdown.isSelectAll}
              showUndated={dropdown.showUndated}
              handleSelectAll={this.handleSelectAll}
              handleOptionSelect={this.handleOptionSelect}
              handleShowUndatedSelect={this.handleShowUndatedSelect}
            />
          </FiltersMobileModal>
        )}
      </Dropdown>
    );
  }
}

export default withComponentName(YearsFilter);
